import React from "react";
import Aboutbanner from "../About/Aboutbanner";
import Contcon from "./Contcon";

function Contact() {
  return (
    <>
      <Aboutbanner name="Contact Us" banner={"../photo/sam4.jpg"} />
      <Contcon />
    </>
  );
}

export default Contact;
